import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Auth0Provider } from '@auth0/auth0-react';
import initSentry from './config/sentry';

// Initialize Sentry with environment-specific configuration
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="login.lexivo.org"
      clientId="UO3wyXGCLvMZWHyDmL7fdojzNFz0pAWJ"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: 'https://arbitration-auth-api/',
        scope: 'openid profile email',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      skipRedirectCallback={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
